export default "__VITE_ASSET__CR8k0IC6__"